import styled from 'styled-components'

export const StyledCellLabeledFamily = styled.div`
  color: var(--color-brand-300);
  font-weight: bold;
  text-align: center;
`

